import "../../css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { faFacebook, faInstagram, faTelegram, faTwitter, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Row, Col } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import MonitorWSService from '../../services/monitorwsservice';
import WidgetSettings from "./widgetSettings"
import { selectionTypes } from "../utils/consts";
import { faRainbow, faSms, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import WidgetTools from "./widgetTools";
import { PieChart, Series, Size, Connector, Legend } from 'devextreme-react/pie-chart';

function SocialSummary(props) {

    const { t } = useTranslation();
    const [all, setAll] = useState(0);
    const [attended, setAttended] = useState(0);
    const [missed, setMissed] = useState(0);
    const [pending, setPending] = useState(0);
    const [arrived, setArrived] = useState(0);
    const [showSettings, setShowSettings] = useState(false);
    const [groupId, setGroupId] = useState(-1);
    const [groupName, setGroupName] = useState(localStorage.getItem(`SocialSummary_groupName_${props.identifier}_user${props.id}`) || t("all2"));
    const [channel, setChannel] = useState(localStorage.getItem(`SocialSummary_channel_${props.identifier}_user${props.id}`) || "");
    const [channelName, setChannelName] = useState(localStorage.getItem(`SocialSummary_channelName_${props.identifier}_user${props.id}`) || "");
    const [callsPercentage, setCallsPercentage] = useState([]);
    const [attendedPercentage, setAttendedPercentage] = useState(0);
    const [oldestAttended, setOldestAttended] = useState("");
    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {

                MonitorWSService.stompClient.send(`/app/unsubscribe/chatssummary`, {}, JSON.stringify({
                    token: props.token,
                    widgetId: props.identifier
                }));

                MonitorWSService.stompClient.unsubscribe(`chatssummary_${props.identifier}`);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        if (props.connected) {

            let groupId = parseInt(localStorage.getItem(`SocialSummary_groupId_${props.identifier}_user${props.id}`) || -1);
            setGroupId(groupId);

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/chatssummary_${props.identifier}/`, function (callssummary) {
                if (!document.hidden && !showSettings) {
                    var data = JSON.parse(callssummary.body);

                    setAll(prev => prev === data.totalCalls ? prev : data.totalCalls);

                    setAttended(data.attendedToday);
                    setMissed(data.missedToday);
                    setArrived(data.arrivedToday);
                    setPending(data.pending);

                    setAttendedPercentage(data.attendedTodayPercentage);

                    if (data.oldestAttended)
                        setOldestAttended(new Date(data.oldestAttended).toLocaleString());

                    setCallsPercentage(prev => {
                        const newCalls = [
                            { state: t("answered"), amount: data.attendedTodayPercentage },
                            { state: t("missed"), amount: data.missedTodayPercentage }
                        ];
                        const same = prev.length === newCalls.length && prev.every((v, i) => v.state === newCalls[i].state && v.amount === newCalls[i].amount);
                        return same ? prev : newCalls;
                    });


                }
            }, { id: `chatssummary_${props.identifier}` });

            MonitorWSService.stompClient.send("/app/subscribe/chatssummary", {}, JSON.stringify({
                token: props.token,
                widgetId: props.identifier,
                groupId: groupId,
                channel: channel
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setGroupAndChannel = (groupId, groupName, channel, channelName) => {
        setShowSettings(!showSettings);
        setGroupId(groupId);
        setGroupName(groupName);
        setChannel(channel);
        setChannelName(channelName);
        localStorage.setItem(`SocialSummary_groupId_${props.identifier}_user${props.id}`, groupId);
        localStorage.setItem(`SocialSummary_groupName_${props.identifier}_user${props.id}`, groupName);
        localStorage.setItem(`SocialSummary_channel_${props.identifier}_user${props.id}`, channel)
        localStorage.setItem(`SocialSummary_channelName_${props.identifier}_user${props.id}`, channelName)
        MonitorWSService.stompClient.send("/app/subscribe/chatssummary", {}, JSON.stringify({
            token: props.token,
            widgetId: props.identifier,
            groupId: groupId,
            channel: channel
        }));

    };

    const closeWidget = (e) => {
        e.preventDefault();
        localStorage.removeItem(`SocialSummary_groupName_${props.identifier}_user${props.id}`)
        localStorage.removeItem(`SocialSummary_groupId_${props.identifier}_user${props.id}`)
        localStorage.removeItem(`SocialSummary_channel_${props.identifier}_user${props.id}`)
        props.close(props.identifier);
    }

    const getIcon = (channel) => {
        let elem = <FontAwesomeIcon icon={duotone("chart-network")} />;
        if (channel === "facebook")
            elem = <FontAwesomeIcon icon={faFacebook} />;
        if (channel === "whatsapp")
            elem = <FontAwesomeIcon icon={faWhatsapp} />;
        if (channel === "instagram")
            elem = <FontAwesomeIcon icon={faInstagram} />;
        if (channel === "twitter")
            elem = <FontAwesomeIcon icon={faTwitter} />;
        if (channel === "sms")
            elem = <FontAwesomeIcon icon={faSms} />;
        if (channel === "telegram")
            elem = <FontAwesomeIcon icon={faTelegram} />;
        if (channel === "rainbow")
            elem = <FontAwesomeIcon icon={faRainbow} />;
        if (channel === "mail")
            elem = <FontAwesomeIcon icon={faEnvelope} />;
        return elem;
    }

    const customizePoint = (e) => {
        if (e.argument === t("answered")) {
            return {
                color: "#50cd89"
            }
        }
        if (e.argument === t("missed")) {
            return {
                color: "#f1416c"
            }
        }
    }

    return (
        <>
            <div className={"card card-flush overflow-hidden widget-container widget-container"}>
                <div className="card-header">
                    <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                        <span className="card-label fw-bold text-primary">{getIcon(channel)} {channelName ? channelName : t("socialnetwors")} - {groupName}</span>
                    </h3>
                    <div className="card-toolbar" style={{ zIndex: 9999 }}>
                        <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                    </div>
                </div>
                <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>

                    <Row>
                        <Col>
                            <div className="fs-3hx fw-bold text-primary text-center">{arrived}</div>
                            <div className="fs-5 fw-semibold mb-7 text-center">{t("arrivedtoday")}</div>
                        </Col>
                        <Col>
                            <div className="fs-3hx fw-bold text-gray-800 text-center">{pending}</div>
                            <div className="fs-5 fw-semibold mb-7 text-center">{t("pending")}</div>
                        </Col>
                        <Col>
                            <div className="fs-3hx fw-bold text-success text-center">{attended}</div>
                            <div className="fs-5 fw-semibold mb-7 text-center">{t("attendedtoday")}</div>
                        </Col>
                        <Col>
                            <div className="fs-3hx fw-bold text-danger text-center">{missed}</div>
                            <div className="fs-5 fw-semibold mb-7 text-center">{t("missedtoday")}</div>
                        </Col>
                        <Col>
                            <PieChart
                                id="socialpercentage"
                                dataSource={callsPercentage}
                                type="doughnut"
                                resolveLabelOverlapping="shift"
                                innerRadius={0.8}
                                customizePoint={customizePoint}
                                rtlEnabled={props.rtl}
                                centerRender={(pie) => {
                                    return (
                                        <svg>
                                            <text textAnchor="middle" x="70" y="70" style={{ fontSize: 18, fill: localStorage.getItem("faTheme") === "light" ? '#3f4254' : "#cdcdde" }}>
                                                <tspan x="100" style={{ fontWeight: 600, fontSize: "30px" }}>{attendedPercentage}%</tspan>
                                            </text>
                                        </svg>
                                    );
                                }}
                            >
                                <Size
                                    height={110}
                                    width={130}
                                />
                                <Series
                                    argumentField="state"
                                    valueField="amount"
                                >
                                    <Connector visible={true}></Connector>
                                </Series>
                                <Legend visible={false}></Legend>
                            </PieChart>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="fs-5 fw-semibold mb-7">{t("oldestattendedtoday")}: {oldestAttended}</div>
                        </Col>
                    </Row>
                </div>

            </div>
            <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroupAndChannel={setGroupAndChannel} groupId={groupId} groupName={groupName} selectionType={selectionTypes.CHANNEL} channel={channel} channelName={channelName}></WidgetSettings>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id
    };
};

export default connect(mapStateToProps, {})(SocialSummary);